import { Tag, baseApi } from './base'
import {
  AdminClaimShiftParams,
  AvailableShift,
  ClaimShiftParams,
  GetAvailableShiftsParams,
  GetMyShiftsParams,
  MyShift,
  PaginatedResponse,
  ReleaseShiftParams,
} from '../models/planning.model'

export const shiftMarketplaceApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getAvailableShifts: builder.query<PaginatedResponse<AvailableShift>, GetAvailableShiftsParams>({
      query: (params) => ({
        url: '/shift-marketplace/available-shifts',
        method: 'GET',
        params,
      }),
      providesTags: (result) =>
        result
          ? [
              ...result.items.map((shift) => ({
                type: Tag.AVAILABLE_SHIFTS as const,
                id: `${shift.planningId}-${shift.shiftTemplateId}-${shift.startTime}`,
              })),
              { type: Tag.AVAILABLE_SHIFTS, id: 'LIST' },
            ]
          : [{ type: Tag.AVAILABLE_SHIFTS, id: 'LIST' }],
    }),

    claimShift: builder.mutation<any, ClaimShiftParams>({
      query: (body) => ({
        url: '/shift-marketplace/claim-shift',
        method: 'POST',
        body,
      }),
      invalidatesTags: (result, error, arg) => [
        { type: Tag.AVAILABLE_SHIFTS, id: 'LIST' },
        { type: Tag.AVAILABLE_SHIFTS, id: `${arg.planningId}-${arg.shiftTemplateId}-${arg.startTime}` },
        { type: Tag.MY_SHIFTS, id: 'LIST' },
      ],
    }),

    getMyShifts: builder.query<PaginatedResponse<MyShift>, GetMyShiftsParams>({
      query: (params) => ({
        url: '/shift-marketplace/my-shifts',
        method: 'GET',
        params,
      }),
      providesTags: (result) =>
        result
          ? [
              ...result.items.map((shift) => ({
                type: Tag.MY_SHIFTS as const,
                id: shift.shiftId,
              })),
              { type: Tag.MY_SHIFTS, id: 'LIST' },
            ]
          : [{ type: Tag.MY_SHIFTS, id: 'LIST' }],
    }),

    releaseShift: builder.mutation<void, ReleaseShiftParams>({
      query: ({ shiftId, staffId }) => ({
        url: `/shift-marketplace/release-shift/${shiftId}`,
        method: 'POST',
        body: { staffId },
      }),
      invalidatesTags: (_result, _error, { shiftId }) => [
        { type: Tag.AVAILABLE_SHIFTS, id: 'LIST' },
        { type: Tag.MY_SHIFTS, id: 'LIST' },
        { type: Tag.MY_SHIFTS, id: shiftId },
        { type: Tag.SHIFT, id: 'LIST' },
        { type: Tag.STAFF, id: 'ELIGIBLE' },
      ],
    }),

    adminClaimShift: builder.mutation<any, AdminClaimShiftParams>({
      query: (body) => ({
        url: '/shift-marketplace/admin-claim-shift',
        method: 'POST',
        body,
      }),
      invalidatesTags: (result, error, arg) => [
        { type: Tag.AVAILABLE_SHIFTS, id: 'LIST' },
        { type: Tag.AVAILABLE_SHIFTS, id: `${arg.planningId}-${arg.shiftTemplateId}-${arg.startTime}` },
        { type: Tag.MY_SHIFTS, id: 'LIST' },
        { type: Tag.STAFF, id: 'ELIGIBLE' },
        { type: Tag.SHIFT, id: 'LIST' },
      ],
    }),

    // New endpoint to check for conflicts before claiming a shift
    checkShiftConflicts: builder.query<{ hasConflict: boolean; conflictDetails: any[] }, { startTime: string; endTime: string }>({
      query: (params) => ({
        url: '/shift-marketplace/check-conflicts',
        method: 'GET',
        params,
      }),
    }),
  }),
  overrideExisting: false,
})
